import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  playerVisible: false,
  currentTrack: '',
  currentPlaylist: null,
  trackIsPlaying: false
}

const audioPlayerSlice = createSlice({
  name: 'audioPlayer',
  initialState,
  reducers: {
    selectTrack: (state, track) => {
        state.currentTrack = track.payload;
    },
    setPlaylist: (state, playlist) => {
      state.currentPlaylist = playlist.payload;
    },
    setPlayerVisible: (state, visible) => {
      state.playerVisible = visible.payload;
    },
    setTrackIsPlaying: (state, isPlaying) => {
      state.trackIsPlaying = isPlaying.payload;
    }
}
})

export const { 
  selectTrack, 
  setPlaylist, 
  setPlayerVisible, 
  setTrackIsPlaying 
} = audioPlayerSlice.actions
export default audioPlayerSlice.reducer